import useSortableData from "../customHook/SortableTable";
import { caseListTableClasses } from "../common/caseListClasses";

const ListingCardTable = ({
    tableHeaders,
    list,
    defaultSortConfigKey = "firstName.lastName",
    tableClassName = `dp-table mt-12! ${caseListTableClasses}`,
    }) => {

    const { items: sortData, requestSort, sortConfig } = useSortableData(list, { direction: "sorting_asc", key: defaultSortConfigKey });
    const getClassNamesFor = (name) => {
        if (!sortConfig) {
            return;
        }
        return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
        <>
            <table className={tableClassName}>
                <thead>
                    <tr>
                        {tableHeaders.map((header, index) => (
                            <th
                                key={index}
                                onClick={header.sortKey ? () => requestSort(header.sortKey) : undefined}
                                className={header.sortKey ? `sorting ${getClassNamesFor(header.sortKey)}` : ''}
                                tabIndex={header.sortKey ? "0" : undefined}
                                aria-controls="myTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-sort={sortConfig?.direction === "sorting_asc" ? "ascending" : "descending"}
                                aria-label={sortConfig?.direction === "sorting_asc" ? "ascending" : "descending"}
                                style={header.style}
                            >
                                {header.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {sortData?.map((row, i) => (
                        <tr key={i}>
                            {tableHeaders.map((header, j) => (
                                <td key={j}>
                                    {header.render ? header.render(row) : row[header.field]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            
        </>
    )
}

export default ListingCardTable;